import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import {
    KYC_STATE_DECLINED,
    KYC_STATE_RETRY,
    KYC_STATE_VALIDATED,
    KYC_USE_CASE_DECLINED_PURCHASE,
    KYC_USE_CASE_FAILURE_BANK_TRANSFER
} from '../../../../services/kyc/constants';
import { PATH } from '../../../../constants/path';
import { APP_NAME, STATIC_ROOT } from '../../../../constants';
import { MODAL_TYPE_KYC } from '../../../../services/modal/constants';
import { DECLINED_PAYMENT_CODE } from '../../../../services/checkout/constants';

import { reset } from '../../../../services/kyc/actions';
import { showModal } from '../../../../services/modal/actions';
import { fetchEbonOrderByIdWithCode, getLogErrorPayment } from '../../../../services/ebon/actions';

import {
    getClickId,
    getLastUserInfoStored,
    getUserId,
    isFailureBankTransferEnabled
} from '../../../../utils/plebicardUtils';
import { getMerchantCardUrl } from '../../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import { getPartner } from '../../../../services/partner/selector';

import Stepper from '../Stepper';
import { Logo } from '../../../icons/Logo';
import HeadComponent from '../../../HeadComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import LinkButtonComponent from '../../../button/LinkButtonComponent';

import { Template } from '../../../template/TemplateStyle';
import { EbonContainerError } from './ErrorEbonPageStyle';
import { HeaderNav } from '../../../header/HeaderNavComponentStyle';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import { Header, HeaderGlobalStyle } from '../../../header/HeaderComponentStyle';

const ErrorEbonPage = ({
    i18n,
    getLogErrorPayment,
    fetchEbonOrderByIdWithCode,
    errorLog,
    orderId,
    paymentId,
    showModal,
    reset,
    history,
    partner,
    status,
    kycState,
    fetchOrder,
    confirmedOrder
}) => {
    const [kycErrorCase, setKycErrorCase] = useState(null);

    const userId = getUserId();
    const clickId = getClickId();
    const userInfo = getLastUserInfoStored();
    const failureBankTransferEnabled = isFailureBankTransferEnabled();

    useEffect(() => {
        if (orderId !== null) {
            getLogErrorPayment(orderId);
            fetchEbonOrderByIdWithCode(orderId, getEffectiveUsername());
        } else {
            getLogErrorPayment('');
        }
    }, []);

    const getEffectiveUsername = () => {
        return clickId || userId || userInfo.email;
    };

    const getErrorMessage = () => {
        if (errorLog && errorLog === 'Refus') {
            return (
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_2)}</li>
                </ul>
            );
        } else if (errorLog && errorLog === '3DSecure') {
            return (
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_3)}</li>
                </ul>
            );
        } else {
            return (
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_2)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_3)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_4)}</li>
                </ul>
            );
        }
    };

    const isKycRequired = () => {
        if (
            !confirmedOrder.verified &&
            !failureBankTransferEnabled &&
            status === DECLINED_PAYMENT_CODE
        ) {
            if (!kycErrorCase) setKycErrorCase(KYC_USE_CASE_DECLINED_PURCHASE);
            return true;
        } else if (!confirmedOrder.verified && failureBankTransferEnabled) {
            if (!kycErrorCase) setKycErrorCase(KYC_USE_CASE_FAILURE_BANK_TRANSFER);
            return true;
        } else {
            return false;
        }
    };

    const showKycModal = () => {
        showModal(MODAL_TYPE_KYC, {
            hideCloseButton: true,
            useCase: kycErrorCase
        });
    };

    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            fetchEbonOrderByIdWithCode(orderId, getEffectiveUsername());
            if (kycErrorCase === KYC_USE_CASE_DECLINED_PURCHASE) {
                reset();
                redirectToMerchantCard();
            }
        }
        if (kycState === KYC_STATE_DECLINED || kycState === KYC_STATE_RETRY) {
            if (kycErrorCase === KYC_USE_CASE_FAILURE_BANK_TRANSFER) {
                reset();
                redirectToMerchantCard();
            }
        }
    }, [kycState]);

    const redirectToMerchantCard = () => {
        if (partner && partner.id) {
            const urlFicheMarchand = getMerchantCardUrl(partner, false, true);
            history.push(urlFicheMarchand);
        } else {
            history.push(PATH.HOME_PATH);
        }
    };

    const showBankTransfer =
        !fetchOrder &&
        confirmedOrder &&
        failureBankTransferEnabled &&
        !isKycRequired() &&
        paymentId &&
        userInfo &&
        userInfo.email;
    const showKyc = !fetchOrder && confirmedOrder && isKycRequired() && userInfo && userInfo.email;

    return (
        <Template className="flex-container-v">
            <HeaderNav className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <Header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <HeaderGlobalStyle />
                        <LocalizedNavLink to={PATH.HOME_PATH} title={APP_NAME} className="logo">
                            <Logo />
                        </LocalizedNavLink>
                        <Stepper steps={i18n.STEPS} current={2} />
                    </Header>
                </div>
            </HeaderNav>
            <EbonContainerError className="conteneur conteneur-mobile">
                <HeadComponent title={i18n.ERROR.TITLE} description={i18n.DESCRIPTION} />
                <Stepper steps={i18n.STEPS} current={2} cssClass="mobileDisplay" />
                <div className="error-container">
                    <h1>{i18n.ERROR.TITLE}</h1>

                    <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_1)}</p>
                    <div className="reasons">{getErrorMessage()}</div>
                    <p>{i18n.ERROR.TEXT_5}</p>
                    <p>{i18n.ERROR.TEXT_6}</p>

                    {fetchOrder ? (
                        <div className="loading">
                            <LoadingComponent />
                        </div>
                    ) : (
                        <React.Fragment>
                            <div className="conteneur-color">
                                <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_7)}</p>
                                {showKyc && (
                                    <LinkButtonComponent
                                        to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                                        text={i18n.ERROR.BUTTON_TEXT}
                                        title={i18n.ERROR.BUTTON_TEXT}
                                        color="main"
                                    />
                                )}
                            </div>

                            {(showBankTransfer || showKyc) && <p>{i18n.ERROR.TEXT_OR}</p>}

                            {showBankTransfer && (
                                <React.Fragment>
                                    <div className="conteneur-color">
                                        <p>
                                            {convertHtmlToReactDomWithParams(
                                                i18n.ERROR.TEXT_IBAN_1,
                                                paymentId
                                            )}
                                        </p>
                                        <div className="iban">
                                            <p className="label">{i18n.ERROR.TEXT_IBAN_2}</p>
                                            <p>{i18n.ERROR.TEXT_IBAN_3}</p>
                                            <p className="label">{i18n.ERROR.TEXT_IBAN_4}</p>
                                            <p>{i18n.ERROR.TEXT_IBAN_5}</p>
                                            <p className="small">{i18n.ERROR.TEXT_IBAN_6}</p>
                                            <p className="label">{i18n.ERROR.TEXT_IBAN_7}</p>
                                            <p>
                                                {convertHtmlToReactDomWithParams(
                                                    i18n.ERROR.TEXT_IBAN_8
                                                )}
                                            </p>
                                            <p className="info">
                                                {convertHtmlToReactDomWithParams(
                                                    i18n.ERROR.TEXT_IBAN_9
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}

                            {showKyc && (
                                <React.Fragment>
                                    <div className="conteneur-color kyc">
                                        <p>
                                            {convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_KYC_1)}
                                        </p>
                                        <ButtonComponent
                                            color="main"
                                            text={i18n.ERROR.TEXT_KYC_BUTTON_TEXT}
                                            onClick={showKycModal}
                                        />

                                        <p className="info">
                                            {convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_KYC_2)}
                                        </p>
                                        <div className="ubble">
                                            <div>{i18n.ERROR.TEXT_KYC_3}</div>
                                            <div>
                                                <img
                                                    src={`${STATIC_ROOT}/kyc/ubble.png`}
                                                    alt="Ubble logo"
                                                    width="100"
                                                    height="37"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}

                            {!showKyc && (
                                <LinkButtonComponent
                                    to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                                    text={i18n.ERROR.BUTTON_TEXT}
                                    title={i18n.ERROR.BUTTON_TEXT}
                                    color="main"
                                />
                            )}
                        </React.Fragment>
                    )}
                    <br />
                </div>
            </EbonContainerError>
        </Template>
    );
};

ErrorEbonPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const orderId = params.orderId;
    const paymentId = orderId ? params.orderId.replaceAll('-', '').substr(0, 8) : null;
    const status = params.code;

    const partnerId = ownProps.match.params.id;
    const partner = getPartner(state, partnerId);

    const confirmedOrder = state.ebon.confirmedOrder;

    return {
        i18n: state.i18n.page.EBON,
        errorLog: state.ebon.logError,
        orderId: orderId,
        paymentId: paymentId,
        partner,
        status: status,
        kycState: state.kyc.state,
        fetchOrder: state.ebon.fetchOrder,
        confirmedOrder: confirmedOrder
    };
};

const mapDispatchToProps = {
    getLogErrorPayment,
    fetchEbonOrderByIdWithCode,
    showModal,
    reset
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ErrorEbonPage.js